import * as Yup from 'yup';

export const validationSchema = Yup.object({
  firstName: Yup.string()
    .max(25, 'Maximum 25 characters allowed')
    .matches(
      /^[a-zA-Z-_]*$/,
      'Only letters, hyphens, and underscores are allowed'
    ),
  lastName: Yup.string()
    .max(25, 'Maximum 25 characters allowed')
    .matches(
      /^[a-zA-Z-_]*$/,
      'Only letters, hyphens, and underscores are allowed'
    ),
  role: Yup.string()
    .max(50, 'Maximum 50 characters allowed')
    .matches(
      /^[a-zA-Z0-9-_ ]*$/,
      'Only letters, numbers, spaces, hyphens, and underscores are allowed'
    ),
});
